import { ICheckboxFilterItem } from "../Filter.interface";

export const tileToFilter = (item: ICheckboxFilterItem) => ({
  fieldName: item.id,
  value: item.checked,
});
